<template>
  <div>
    <baseMap
      ref="mapRef"
      :class="props.isView ? 'map map_view' : 'map'"
      @mounted="mapMounted"
    />
  </div>
</template>

<script setup>
  import {
    defineProps,
    defineEmits,
    ref,
  } from 'vue'
  import baseMap from '@/components/map/base_map'
  //初始化
  const emit = defineEmits()
  const mapRef = ref()
  const props = defineProps({
    modelValue: Array,
    isView: Boolean,
  })

  function mapMounted(map) {
    //配置工具栏
    map.pm.setLang('zh')

    let center = ['22.744976', '114.524402'] //中心纬经度
    if (props.modelValue) {
      center = [props.modelValue[0][0], props.modelValue[0][1]]
    }
    const normalConfig = {
      // editMode: false,
      cutPolygon: false,
      // rotateMode: false,
      removalMode: false,
      drawPolygon: false,
      drawText: false,
      drawMarker: false,
      drawCircle: false,
      drawPolyline: false,
      drawRectangle: false,
      drawCircleMarker: false,
    }

    const allBanConfig = {
      ...normalConfig,
      editMode: false,
      rotateMode: false,
      dragMode: false,
    }

    if (props.modelValue) {
      //有传入标点，进入编辑模式

      //居中
      mapRef.value.flyTo(props.modelValue[0][1], props.modelValue[0][0])
      //绘制标点
      window.L.polyline(props.modelValue)
        .on('pm:edit', function fn(e) {
          //监听编辑模式
          lineChange(e.marker?._latlngs || e.target?._latlngs)
        })
        .addTo(map)

      //配置编辑模式
      map.pm.addControls(props.isView ? allBanConfig : normalConfig)

      //进入编辑模式
      !props.isView && map.pm.enableGlobalEditMode()
    } else {
      //如果没有传入经纬度则进入选点模式
      map.on('pm:create', function fn(e) {
        lineChange(e.marker?._latlngs || e.target?._latlngs)
        //禁用继续标点
        map.pm.disableDraw()
        map.pm.enableGlobalEditMode()
        map.pm.addControls({
          // drawMarker: false,
          drawPolyline: false,
          dragMode: true,
        })

        //监听编辑事件
        e.layer.on('pm:edit', function fn(e) {
          lineChange(e.marker?._latlngs || e.target?._latlngs)
        })
      })

      map.pm.addControls(normalConfig)
      //进入绘制模式
      map.pm.enableDraw('Line')
    }
  }
  function latLngsToList(latLngs) {
    return latLngs.map((item) => [item.lat, item.lng])
  }
  function lineChange(list) {
    emit('update:modelValue', latLngsToList(list))
    // emit('update:modelValue', list)
  }
</script>

<style lang="less" scoped>
  .map {
    height: calc(100vh - 219px) !important;
  }
  .map_view {
    height: calc(100vh - 119px) !important;
  }
</style>
